Vendd.Scripts.load(function () {

	var $wrapper = $('.x-warehouse-selector-widget');

	if ($wrapper.length < 1) {
		return;
	}

	var wrapper = $wrapper.get(0),
		$root,
		$button;

	var state = {
		mode: undefined,
		isDisplayed: undefined,
		isRequired: undefined,
		isSpecified: undefined,
		selectionKey: undefined,
		forceDisplay: undefined
	};

	function shouldOpenUnconditionally() {
		return state.forceDisplay;
	}
	function shouldOpenOnStartup() {
		return shouldOpenUnconditionally() || !state.isSpecified && state.mode === 'startup' && !state.isDisplayed;
	}
	function shouldOpenOnAddToCart() {
		return shouldOpenOnStartup() || !state.isSpecified && state.mode === 'addtocart' && (!state.isDisplayed || state.isRequired);
	}
	function shouldOpenOnCheckout() {
		return shouldOpenOnAddToCart() || !state.isSpecified && state.mode === 'checkout' && (!state.isDisplayed || state.isRequired);
	}
	function shouldOpen() {
		return !state.isSpecified;
	}

	var shouldOpenConditions = {
		'force': shouldOpenUnconditionally,
		'startup': shouldOpenOnStartup,
		'addtocart': shouldOpenOnAddToCart,
		'checkout': shouldOpenOnCheckout,
		'default': shouldOpen
	};

	wrapper.init = function () {
		$root = $('.warehouse-selector-widget', $wrapper);
		$button = $('.js-select-warehouse', $root);
		$button.toggleDisabled($('.x-warehouse-selector-popup').length === 0);

		var data = $root.data();
		var selectionKey = data.selectionKey;

		if ((state.selectionKey !== undefined) && (state.selectionKey !== selectionKey)) {
			window.location.reload();
			return;
		}

		state.mode = data.displayMode;
		state.isDisplayed = !!parseInt(data.displayCount);
		state.isRequired = !!parseInt(data.isRequired);
		state.isSpecified = !!parseInt(data.isSpecified);
		state.selectionKey = selectionKey;
		state.forceDisplay = !!parseInt(data.forceDisplay);

		/* console.log('[WarehouseSelector] Data: ' + JSON.stringify($root.data())); */
		/* console.log('[WarehouseSelector] Displayed: ' + state.isDisplayed + ', Required: ' + state.isRequired + ', Specified: ' + state.isSpecified); */

		$wrapper.css({ display: '' });
		wrapper.open('startup');
	};

	/** Opens the warehouse popup selector conditionally
	 * 
	 * @param {any} condition Controls the condition that should be met to open the popup selector.
	 *		Possible values are:
	 *			true (or undefined): Opens the selector unconditionally (force)
	 *			false : Opens only if still not specified.
	 *			'startup' : Once upon landing, if still not specified.
	 *			'addtocart' : Upon adding something to cart, if still not specified; only once if not required.
	 *			'checkout' : Upon proceeding to checkout, if still not specified; only once if not required.
	 * @returns true if the popup selector opens; false otherwise.
	 */
	wrapper.open = function (condition) {
		console.log('[WarehouseSelector] Displayed: ' + state.isDisplayed + ', Required: ' + state.isRequired + ', Specified: ' + state.isSpecified);
		if ((condition === undefined) ||
			(condition === true) ||
			(condition === false && !state.isSpecified) ||
			(typeof shouldOpenConditions[condition] === 'function' && shouldOpenConditions[condition]())) {
			Vendd.MessageBus.publish(wrapper, new Vendd.WarehouseSelector.Messages.OpenPopup());
			return true;
		}
		return false;
	};

	/* Opens the warehouse popup selector as part of a jQuery trigger('addtocart') operation.
	 * 
	 * Example:
	 * 
	 *	if ($('.x-warehouse-selector-widget').trigger('addtocart').hasClass('opening')) {
	 *		// The warehouse selector is installed and about to open.
	 *	}
	 */
	wrapper.onaddtocart = function () {
		wrapper.open('addtocart');
	};

	/* Opens the warehouse popup selector as part of a jQuery trigger('checkout') operation.
	 *
	 * Example:
	 *
	 *	if ($('.x-warehouse-selector-widget').trigger('checkout').hasClass('opening')) {
	 *		// The warehouse selector is installed and about to open.
	 *	}
	 */
	wrapper.oncheckout = function () {
		wrapper.open('checkout');
	};

	wrapper.refresh = function () {
		wrapper.loading(true);
		Vendd.MessageBus.publish(wrapper, new Vendd.WarehouseSelector.Messages.GetModel());
	};

	wrapper.update = function (model) {
		/* console.log('[WarehouseSelector] Widget JSON model: ' + JSON.stringify(model)); */
		var html = Vendd.Handlebars.parse("warehouseSelectorWidget_A", model);
		$wrapper.html(html);
		wrapper.init();
	};

	wrapper.loading = function (status) {
		if (status === undefined) {
			return $wrapper.hasClass('x-loading');
		} else {
			$wrapper.toggleClass('x-loading', status);
		}
	};

	$wrapper.on('click', '.js-select-warehouse', function (e) {
		e.preventDefault();
		wrapper.open();
	});

	Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.GetModelSuccess, wrapper, function (envelope) {
		wrapper.loading(false);
		wrapper.update(envelope.message.data.data);
	});

	Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.GetModelFailed, wrapper, function () {
		wrapper.loading(false);
	});

	Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.SetShippingMethodSuccess, wrapper, function () {
		wrapper.refresh();
	});

	Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.StateChanged, wrapper, function (envelope) {
		/* console.log('[WarehouseSelector] Modal dialog state changed: ' + envelope.message.data.state); */
		$wrapper.removeClass('opening opened closing closed').addClass(envelope.message.data.state);
		state.isDisplayed = true;
	});


	/* Initialization */

	/* 
	 * NOTE: The 'wrapper.init()' method initializes the widget using the static HTML data, which might
	 * be stale, due to aggressive caching of CDNs. Calling the 'wrapper.refresh()' method, forces a
	 * dynamic fetch of the widget's most up-to-date content model (preventing unecessary display of the
	 * popup selector).
	 * 
	 * PS. It might be a good idea to make this an back-office controlled option.
	 * 
	 * --charizakis (2021-01-21)
	 */
	wrapper.refresh(); /* - OR - wrapper.init(); */
});
